import React from 'react'
import FormGroup from '@mui/material/FormGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import { connect } from 'react-redux'
import { setFooterRecipients } from '../../../firebase/database/mailFooterHandler'
import Card from '@material-ui/core/Card'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import { setMailFooterActive } from '../../../firebase/database/mailFooterHandler'
import Switch from '@material-ui/core/Switch'

const appSelectorByShortcut = {
    nh: 'nachbarschaftshilfe',
    pk: 'pflegekasse'
}

function MailFooterOptions({recipients, isActive}) {
    const handleChange = e => {
        const _recipients = {
            ...recipients
        }
        const targetId = e.target.id 
        const appKz = targetId.substring(0,2)
        const app = appSelectorByShortcut[appKz]
        const memberType = targetId.slice(3)

        _recipients[app][memberType] = e.target.checked

        return setFooterRecipients(_recipients)
    }
    const handleSwitchChange =() => {
        return setMailFooterActive(!isActive)
    }
    const nbIsActive = recipients.nachbarschaftshilfe.requester || recipients.nachbarschaftshilfe.provider
    const pkIsActive = recipients.pflegekasse.requester || recipients.pflegekasse.provider
    const nbColorTypo = {color: nbIsActive ? 'whitesmoke' : 'black'}
    const nbColorBg = {backgroundColor: nbIsActive ? '#3f51b5' : 'lightblue', padding: '0.3rem 0.5rem 0.0rem 0.5rem'}
    const pkColorTypo = {color: pkIsActive ? 'whitesmoke' : 'black'}
    const pkColorBg = {backgroundColor: pkIsActive ? '#f50057' : 'lightblue', padding: '0.3rem 0.5rem 0.0rem 0.5rem'}

    return (
    <FormGroup >
        <Grid container spacing={2} alignItems="stretch" justifyContent='flex-start' >
            <Grid item md={3} style={{paddingLeft: 0}}>
                <Card style={{backgroundColor: isActive ? 'rgba(255, 0, 0, 0.5)' : 'lightblue', paddingLeft: '0.5rem', paddingRight: '0.5rem', paddingTop: '0.5rem'}} >
                    <Typography style={{textTransform: 'uppercase'}} variant='body2'  >Footer aktivieren</Typography>
                    <FormControlLabel
                        control={<Switch
                            checked={isActive}
                            onChange={handleSwitchChange}
                        />} 
                        color='error'
                        label={isActive ? 'Aktiviert' : "Aktivieren"}
                    />
                </Card>
            </Grid>
            <Grid item md={3} >
                <Card style={nbColorBg}>
                    <Typography variant='body2' style={{...nbColorTypo, textTransform: 'uppercase'}} >Nachbarschaftshilfe</Typography>
                    <FormControlLabel style={nbColorTypo} checked={recipients.nachbarschaftshilfe.requester} onChange={handleChange} control={<Checkbox id='nh-requester' style={nbColorTypo} />} label="Bedarf" />
                    <FormControlLabel style={nbColorTypo} checked={recipients.nachbarschaftshilfe.provider} onChange={handleChange} required control={<Checkbox style={nbColorTypo}  id='nh-provider' />} label="Helfer" />
                </Card>
            </Grid>
            <Grid item md={3} >
                <Card style={pkColorBg}>
                    <Typography variant='body2' style={{...pkColorTypo, textTransform: 'uppercase'}} >Pflegekasse</Typography>
                    <FormControlLabel style={pkColorTypo} checked={recipients.pflegekasse.requester} onChange={handleChange} control={<Checkbox style={pkColorTypo} id='pk-requester' color='secondary'/>} label="Bedarf" />
                    <FormControlLabel style={pkColorTypo} checked={recipients.pflegekasse.provider} onChange={handleChange} control={<Checkbox style={pkColorTypo} id='pk-provider' />} label="Helfer" />
                </Card>
            </Grid>
            <Grid item md={3} >
                <Card style={{backgroundColor: isActive ? 'rgba(255, 0, 0, 0.5)' : 'lightblue', paddingLeft: '0.5rem', paddingRight: '0.5rem', paddingTop: '0.5rem'}} >
                    <Typography variant='h3' align='center' style={{textTransform: 'uppercase', color: 'whitesmoke'}}>
                        {isActive ? 'An' : 'Aus'}
                    </Typography>
                </Card>
            </Grid>
        </Grid>
    </FormGroup>
  );
}

export default connect((state) => ({
    recipients: state.mailFooter.recipients,
    isActive: state.mailFooter.isActive,
})) 
(MailFooterOptions)